const ArticleTabs = (() => {
	return {
		init: () => {
			const headerTabs = document.querySelectorAll('.articles-tabs__tab-header-item');

			if (!headerTabs.length) return;

			headerTabs.forEach((tab) => {
				tab.addEventListener('click', function () {
					const target = this.getAttribute('data-tab');
					if (!target) return;

					const bodyTab = document.querySelector(`.articles-tabs__tab-body-item[data-tab="${target}"]`);
					if (!bodyTab) return;

					document
						.querySelectorAll('.articles-tabs__tab-body-item--active')
						.forEach((el) => el.classList.remove('articles-tabs__tab-body-item--active'));

					bodyTab.classList.add('articles-tabs__tab-body-item--active');

					this.classList.add('articles-tabs__tab-header-item--active');
					
					const activeHeaderTab = document.querySelector(`.articles-tabs__tab-header-item:not([data-tab="${target}"])`);
					if (!activeHeaderTab) return;
					activeHeaderTab.classList.remove('articles-tabs__tab-header-item--active');
				});
			});
		}
	};
})();

export default ArticleTabs;

document.addEventListener("DOMContentLoaded", () => {
  ArticleTabs.init();
});